import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import StudentHeader from "../components/StudentHeader";
import ErrorPage from "./ErrorPage";
import { studentModules, taskLevels } from "../data/studentModules";
import { loadProgress, saveModuleProgress, moduleStatus, statusLabels } from "../data/modulesStore";

const tabs = [
    { id: "theory", label: "Maqsad va nazariya" },
    { id: "sample", label: "Namunaviy mashg'ulot" },
    { id: "tasks", label: "Topshiriqlar" },
    { id: "worksheet", label: "Ish varag'i" },
    { id: "rubric", label: "O'z-o'zini baholash" },
];

const ratings = [
    { value: 0, label: "Yo'q" },
    { value: 1, label: "Qisman" },
    { value: 2, label: "To'liq" },
];

const inputStyle = { padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%", resize: "vertical" };
const cardStyle = { background: "#fafafa", borderRadius: 12, padding: 20, marginBottom: 16 };

const escapeHtml = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]));

function StudentModuleView({ id }) {
    const index = studentModules.findIndex((m) => m.id === id);
    const module = studentModules[index];
    const [tab, setTab] = useState("theory");
    const [data, setData] = useState(() => loadProgress()[id] || { worksheet: {}, rubric: {} });

    if (!module) return <ErrorPage />;

    const update = (next) => {
        setData(next);
        saveModuleProgress(module.id, next);
    };

    const status = statusLabels[moduleStatus(module, data)];
    const rubricScore = Object.values(data.rubric).reduce((a, b) => a + b, 0);
    const rubricMax = module.rubric.length * 2;
    const rubricDone = Object.keys(data.rubric).length === module.rubric.length;
    const prev = studentModules[index - 1];
    const next = studentModules[index + 1];

    // Butun ishlanma va talabaning javoblarini chop etish (PDF sifatida saqlash mumkin)
    const print = () => {
        const w = window.open("", "_blank");
        if (!w) return;
        const s = module.sample;
        const list = (items) => `<ul>${items.map((x) => `<li>${escapeHtml(x)}</li>`).join("")}</ul>`;
        w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(module.title)}</title>
            <style>body{font-family:Arial,sans-serif;max-width:800px;margin:30px auto;color:#222;line-height:1.5;font-size:14px}
            h1{font-size:20px;text-align:center}h2{font-size:16px;border-bottom:1px solid #ccc;padding-bottom:4px;margin-top:24px}
            table{width:100%;border-collapse:collapse}td,th{border:1px solid #999;padding:6px;vertical-align:top;text-align:left}
            .answer{border:1px solid #ccc;min-height:40px;padding:6px;margin-bottom:8px;white-space:pre-wrap}</style></head><body>
            <h1>${escapeHtml(module.title)}</h1><p style="text-align:center">${escapeHtml(module.hours)}</p>
            <h2>Maqsad</h2><p>${escapeHtml(module.goal)}</p>
            <h2>Kutiladigan natijalar</h2>${list(module.outcomes)}
            <h2>Tayanch tushunchalar</h2>${list(module.concepts.map((c) => `${c.term} — ${c.def}`))}
            <h2>Qisqa nazariya</h2>${module.theory.map((p) => `<p>${escapeHtml(p)}</p>`).join("")}
            <h2>Namunaviy mashg'ulot: ${escapeHtml(s.topic)}</h2>
            <p><b>Guruh:</b> ${escapeHtml(s.group)} · <b>Davomiyligi:</b> ${escapeHtml(s.duration)}</p>
            <p><b>Maqsad:</b> ${escapeHtml(s.goal)}</p><p><b>Jihozlar:</b> ${escapeHtml(s.equipment)}</p>
            <table><tr><th>Bosqich</th><th>Vaqt</th><th>Tarbiyachi faoliyati</th><th>Bolalar faoliyati</th></tr>
            ${s.stages.map((st) => `<tr><td>${escapeHtml(st.name)}</td><td>${escapeHtml(st.time)}</td><td>${escapeHtml(st.teacher)}</td><td>${escapeHtml(st.children)}</td></tr>`).join("")}</table>
            <p><b>Baholash:</b> ${escapeHtml(s.evaluation)}</p>
            <h2>Amaliy topshiriqlar</h2>${list(module.tasks.map((t) => `${taskLevels[t.level].label}: ${t.text}`))}
            <h2>Ish varag'i</h2>${module.worksheet.map((f) => `<p><b>${escapeHtml(f.label)}</b></p><div class="answer">${escapeHtml(data.worksheet[f.id] || "")}</div>`).join("")}
            <h2>O'z-o'zini baholash</h2><table><tr><th>Mezon</th><th>Baho</th></tr>
            ${module.rubric.map((r, i) => `<tr><td>${escapeHtml(r)}</td><td>${data.rubric[i] === undefined ? "" : ratings[data.rubric[i]].label}</td></tr>`).join("")}</table>
            <h2>Nazorat savollari</h2>${list(module.questions)}
            <h2>Mustaqil ish</h2><p>${escapeHtml(module.homework)}</p>
            </body></html>`);
        w.document.close();
        w.focus();
        w.print();
    };

    return (
        <>
            <StudentHeader title={`${index + 1}-ishlanma`} crumb={module.methodId} />
            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box mb-5">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">{module.title}</h3>
                                <p className="pricing-one__text">
                                    {module.hours} · Holati: <strong style={{ color: status.color }}>{status.label}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5" style={{ paddingBottom: 40 }}>
                            <div className="d-flex mb-4" style={{ gap: 8, flexWrap: "wrap" }}>
                                {tabs.map((t, i) => (
                                    <button key={t.id} onClick={() => setTab(t.id)} style={{
                                        padding: "10px 16px", borderRadius: 8, cursor: "pointer", fontWeight: 600,
                                        border: tab === t.id ? "2px solid #ffb606" : "1px solid #ddd",
                                        background: tab === t.id ? "#ffb606" : "#fff",
                                        color: tab === t.id ? "#fff" : "#333"
                                    }}>
                                        {i + 1}. {t.label}
                                    </button>
                                ))}
                            </div>

                            {tab === "theory" && (
                                <>
                                    <div style={cardStyle}>
                                        <h4>Mashg'ulot maqsadi</h4>
                                        <p style={{ margin: 0 }}>{module.goal}</p>
                                    </div>
                                    <div style={cardStyle}>
                                        <h4>Kutiladigan natijalar — talaba:</h4>
                                        <ul className="pricing-one__card__list" style={{ margin: 0 }}>
                                            {module.outcomes.map((o, i) => (
                                                <li key={i}><span className="pricing-one__card__list__icon"><i className="icon-check"></i></span>{o}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div style={cardStyle}>
                                        <h4>Tayanch tushunchalar</h4>
                                        {module.concepts.map((c) => (
                                            <p key={c.term} style={{ marginBottom: 8 }}><strong>{c.term}</strong> — {c.def}</p>
                                        ))}
                                    </div>
                                    <div style={cardStyle}>
                                        <h4>Qisqa nazariy ma'lumot</h4>
                                        {module.theory.map((p, i) => <p key={i}>{p}</p>)}
                                        <Link to={module.methodPath} style={{ color: "#ffb606", fontWeight: 600 }}>Metod haqida batafsil →</Link>
                                    </div>
                                </>
                            )}

                            {tab === "sample" && (
                                <>
                                    <div style={cardStyle}>
                                        <h4>Mavzu: "{module.sample.topic}"</h4>
                                        <p style={{ marginBottom: 6 }}><strong>Guruh:</strong> {module.sample.group} · <strong>Davomiyligi:</strong> {module.sample.duration}</p>
                                        <p style={{ marginBottom: 6 }}><strong>Maqsad:</strong> {module.sample.goal}</p>
                                        <p style={{ margin: 0 }}><strong>Jihozlar:</strong> {module.sample.equipment}</p>
                                    </div>
                                    <h4 className="mb-3">Mashg'ulotning borishi</h4>
                                    <div style={{ overflowX: "auto" }}>
                                        <table className="table" style={{ minWidth: 640 }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "18%" }}>Bosqich</th>
                                                    <th style={{ width: "10%" }}>Vaqt</th>
                                                    <th>Tarbiyachi faoliyati</th>
                                                    <th>Bolalar faoliyati</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {module.sample.stages.map((s, i) => (
                                                    <tr key={i}>
                                                        <td><strong>{s.name}</strong></td>
                                                        <td>{s.time}</td>
                                                        <td>{s.teacher}</td>
                                                        <td>{s.children}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={cardStyle}>
                                        <strong>Natijani baholash:</strong> {module.sample.evaluation}
                                    </div>
                                </>
                            )}

                            {tab === "tasks" && (
                                <>
                                    <p style={{ color: "#666" }}>Topshiriqlar oddiydan murakkabga qarab berilgan. Kamida ikkitasini bajaring; natijani ish varag'iga yozing.</p>
                                    {module.tasks.map((t, i) => {
                                        const lvl = taskLevels[t.level];
                                        return (
                                            <div key={i} style={{ ...cardStyle, borderLeft: `4px solid ${lvl.color}` }}>
                                                <span style={{ color: lvl.color, fontWeight: 700 }}>{i + 1}. {lvl.label}</span>
                                                <span style={{ color: "#999", fontSize: 13, marginLeft: 8 }}>{lvl.hint}</span>
                                                <p style={{ margin: "8px 0 0" }}>{t.text}</p>
                                            </div>
                                        );
                                    })}
                                    <div style={cardStyle}>
                                        <h4>Nazorat savollari</h4>
                                        <ol style={{ paddingLeft: 20, margin: 0 }}>
                                            {module.questions.map((q, i) => <li key={i} style={{ marginBottom: 6 }}>{q}</li>)}
                                        </ol>
                                    </div>
                                    <div style={{ ...cardStyle, background: "#fff8e6" }}>
                                        <strong>Mustaqil ish:</strong> {module.homework}
                                    </div>
                                </>
                            )}

                            {tab === "worksheet" && (
                                <>
                                    <p style={{ color: "#666" }}>Ish varag'ini to'ldiring — javoblaringiz avtomatik saqlanadi. Tayyor bo'lgach chop etib, o'qituvchiga topshirishingiz mumkin.</p>
                                    {module.worksheet.map((f) => (
                                        <div key={f.id} className="mb-3">
                                            <label className="d-block mb-2"><strong>{f.label}</strong></label>
                                            <textarea
                                                rows={f.rows || 2}
                                                style={inputStyle}
                                                value={data.worksheet[f.id] || ""}
                                                onChange={(e) => update({ ...data, worksheet: { ...data.worksheet, [f.id]: e.target.value } })}
                                            />
                                        </div>
                                    ))}
                                </>
                            )}

                            {tab === "rubric" && (
                                <>
                                    <p style={{ color: "#666" }}>Ish varag'idagi loyihangizni har bir mezon bo'yicha halol baholang.</p>
                                    {module.rubric.map((r, i) => (
                                        <div key={i} className="d-flex justify-content-between align-items-center" style={{ ...cardStyle, gap: 12, flexWrap: "wrap", padding: 14 }}>
                                            <span>{i + 1}. {r}</span>
                                            <div className="d-flex" style={{ gap: 6 }}>
                                                {ratings.map((rt) => {
                                                    const active = data.rubric[i] === rt.value;
                                                    const color = ["#ef4444", "#f59e0b", "#10b981"][rt.value];
                                                    return (
                                                        <button key={rt.value} onClick={() => update({ ...data, rubric: { ...data.rubric, [i]: rt.value } })} style={{
                                                            padding: "6px 12px", borderRadius: 6, cursor: "pointer",
                                                            border: `1px solid ${active ? color : "#ddd"}`,
                                                            background: active ? color : "#fff", color: active ? "#fff" : "#333"
                                                        }}>
                                                            {rt.label}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                    {rubricDone && (
                                        <div className="text-center" style={{ ...cardStyle, background: "#fff8e6" }}>
                                            <h3 style={{ color: "#ffb606", margin: 0 }}>{rubricScore} / {rubricMax}</h3>
                                            <p style={{ margin: "6px 0 0" }}>
                                                {rubricScore / rubricMax >= 0.8
                                                    ? "A'lo! Loyihangiz metod talablariga to'liq javob beradi."
                                                    : rubricScore / rubricMax >= 0.5
                                                        ? "Yaxshi. \"Qisman\" deb belgilagan mezonlarni qayta ko'rib chiqing."
                                                        : "Namunaviy mashg'ulotni qayta tahlil qilib, ish varag'ini to'ldiring."}
                                            </p>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className="d-flex justify-content-between align-items-center mt-4" style={{ gap: 12, flexWrap: "wrap" }}>
                                <button onClick={print} className="eduhive-btn" style={{ border: "none" }}>
                                    <span>Ishlanmani chop etish / PDF</span>
                                </button>
                                <div className="d-flex" style={{ gap: 16 }}>
                                    {prev && <Link to={`/student-modules/${prev.id}`} style={{ color: "#666" }}>← Oldingi ishlanma</Link>}
                                    {next && <Link to={`/student-modules/${next.id}`} style={{ color: "#ffb606", fontWeight: 600 }}>Keyingi ishlanma →</Link>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-8 col-lg-3 mx-auto">
                            <Link to="/student-modules" className="course-details__info__btn eduhive-btn">
                                <span className="eduhive-btn__text">Barcha ishlanmalar</span>
                                <span className="eduhive-btn__icon">
                                    <span className="eduhive-btn__icon__inner"><i className="icon-arrow-right"></i></span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

// Boshqa ishlanmaga o'tilganda holat yangidan yuklanishi uchun key ishlatiladi
function StudentModule() {
    const { id } = useParams();
    return <StudentModuleView key={id} id={id} />;
}

export default StudentModule;
